import React, { useState, useEffect,useRef  } from 'react'; 
import { editProfileAPI } from '../services/userApi'; 
import Swal from 'sweetalert2'; 
import { useNavigate } from 'react-router-dom'; 
import backgroundImage from '../assets/Bg.jpg'; 
import withReactContent from 'sweetalert2-react-content';

const EditProfilePage = () => {
  const MySwal = withReactContent(Swal);
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1025);
  const [activePage, setActivePage] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const storedData = JSON.parse(localStorage.getItem('account'));
  const [userData, setUserData] = useState({
    email:'',
    education_number:'',
    first_name:'',
    last_name:'',
    nick_name:'',
    rank_position:'',
    short_position:'',
    birthday:'',
    birthday:'',
    religion:'',
    marital_status:'',
    phone:'',
    emergency_contact_phone:'',
    emergency_contact_relationship:'',
    department:'',
    military_branch:'',
    military_type:'',
    hometown:'',
    responsibility:'',
    training_course:'',
    residence_during_study:'',
    transportation_method:'',
    vehicle_registration_number:'',
    blood_group:'',
    chronic_illness:'',
    allergy:'',
    drug_allergy:'',
    physical_limitation:'',
    highest_education_level:'',
    hobby:'',
    role:'',
  });
  const [fileName, setFileName] = useState(""); // state สำหรับเก็บชื่อไฟล์ที่เลือก
  const [fileData, setFileData] = useState(null);
  const fileInputRef = useRef(null);

  const pages = [
    'ข้อมูลส่วนตัว',
    'ข้อมูลการทำงาน',
    'ที่พักและการเดินทาง',
    'ข้อมูลด้านสุขภาพ',
    'ข้อมูลการศึกษาและงานอดิเรก'
  ];
  

  const handleResize = () => {
    setIsSmallScreen(window.innerWidth < 1025);
  };

  useEffect(() => {
    fetchUserData();
    window.addEventListener('resize', handleResize);
    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('resize', handleResize);
    };

    document.body.style.overflow = 'auto';
  }, []);

  const fetchUserData = () => {
    try {
     
      console.log("UID:", storedData);
  
      if (storedData) {
        // ตั้งค่า state ของผู้ใช้
        setUser(storedData);
  
        // ตั้งค่า userData
        setUserData({
          uid: storedData.uid,
          email: storedData.email,
          education_number: storedData.education_number,
          first_name: storedData.first_name,
          last_name: storedData.last_name,
          nick_name: storedData.nick_name,
          rank_position: storedData.rank_position,
          short_position: storedData.short_position,
          full_position: storedData.full_position,
          birthday: storedData.birthday,
          religion: storedData.religion,
          marital_status: storedData.marital_status,
          phone: storedData.phone,
          emergency_contact_phone: storedData.emergency_contact_phone,
          emergency_contact_relationship: storedData.emergency_contact_relationship,
          image: storedData.image,
          department: storedData.department,
          military_branch: storedData.military_branch,
          military_type: storedData.military_type,
          hometown: storedData.hometown,
          responsibility: storedData.responsibility,
          training_course: storedData.training_course,
          residence_during_study: storedData.residence_during_study,
          transportation_method: storedData.transportation_method,
          vehicle_registration_number: storedData.vehicle_registration_number,
          blood_group: storedData.blood_group,
          chronic_illness: storedData.chronic_illness,
          allergy: storedData.allergy,
          drug_allergy: storedData.drug_allergy,
          physical_limitation: storedData.physical_limitation,
          highest_education_level: storedData.highest_education_level,
          hobby: storedData.hobby
        });
        setFileName(storedData.image_url?.split("/").pop());
      }
    } catch (error) {
      console.error('Failed to fetch user data:', error);
    }
  };
    const onSuccess = (title, message) => {
    MySwal.fire({
      icon: 'success',
      title: title,
      text: message,
      confirmButtonText: 'OK',
      allowOutsideClick: false
    });
  };

  const onError = (title, response) => {
    MySwal.fire({
      title: title,
      html: response?.data?.error?.message,
      icon: "error",
      confirmButtonText: "Close",
      allowOutsideClick: false
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (response?.status === 401) {
          sessionStorage.removeItem('hasVisited');
          sessionStorage.removeItem('lastPath');
          localStorage.removeItem('account');
          navigate('/');
        }
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    console.log("UID:", userData.uid);
    console.log(userData); // ตรวจสอบข้อมูลที่ส่งไป
  
    try {
      // สร้าง FormData เพื่อส่งข้อมูลพร้อมไฟล์
      const formData = new FormData();
  
      // เพิ่มข้อมูลโปรไฟล์ลงใน FormData
      formData.append("user_uid", userData.uid);
      formData.append("email", userData.email);
      formData.append("education_number", userData.education_number);
      formData.append("first_name", userData.first_name);
      formData.append("last_name", userData.last_name);
      formData.append("nick_name", userData.nick_name);
      formData.append("rank_position", userData.rank_position);
      formData.append("short_position", userData.short_position);
      formData.append("full_position", userData.full_position);
      formData.append("birthday", userData.birthday);
      formData.append("religion", userData.religion);
      formData.append("marital_status", userData.marital_status);
      formData.append("phone", userData.phone);
      formData.append("emergency_contact_phone", userData.emergency_contact_phone);
      formData.append("emergency_contact_relationship", userData.emergency_contact_relationship);
      formData.append("department", userData.department);
      formData.append("military_branch", userData.military_branch);
      formData.append("military_type", userData.military_type);
      formData.append("hometown", userData.hometown);
      formData.append("responsibility", userData.responsibility);
      formData.append("training_course", userData.training_course);
      formData.append("residence_during_study", userData.residence_during_study);
      formData.append("transportation_method", userData.transportation_method);
      formData.append("vehicle_registration_number", userData.vehicle_registration_number);
      formData.append("blood_group", userData.blood_group);
      formData.append("chronic_illness", userData.chronic_illness);
      formData.append("allergy", userData.allergy);
      formData.append("drug_allergy", userData.drug_allergy);
      formData.append("physical_limitation", userData.physical_limitation);
      formData.append("highest_education_level", userData.highest_education_level);
      formData.append("hobby", userData.hobby);
  
      formData.append('image', fileData);   
  
      // ตรวจสอบข้อมูลก่อนส่ง
      console.log("FormData to be sent:", formData);
  
      // ส่งข้อมูลไปยัง API โดยใช้ editProfileAPI
      const result = await editProfileAPI(formData);
  
      console.log("Data to be sent:", result);
      if (result.status) {
        console.log('Profile updated successfully:', result);
        
        localStorage.setItem("account", JSON.stringify(result.data.account));
    
        // นำทางไปที่หน้าโปรไฟล์
        navigate('/Profile');
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      onError('ไม่สามารถบันทึกข้อมูลได้', error?.response || { data: { error: { message: 'An unexpected error occurred' } } });
    }
  };
        
  const handleChange = (event) => {
    const { name, value, files } = event.target;

    if (files) {
      // หากมีไฟล์ที่เลือกมา
      setUserData({
        ...userData,
        [name]: files[0], // เก็บไฟล์แรกใน state
      });
      setFileName(files[0].name); // เก็บชื่อไฟล์ใน state สำหรับแสดงในช่อง input
    } else {
      // อัปเดตค่าใน input อื่นๆ
      setUserData({
        ...userData,
        [name]: value,
      });
    }
  };
  
  const onFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
        setFileData(selectedFile);
        setFileName(selectedFile.name);
    }
}; 
  
const onUploadFile = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
};      
const imageFileTypes = [
    { accept: 'image/png', ext: '.png' },
    { accept: 'image/jpeg', ext: '.jpg' }
];      

const openModal = () => {
  setIsModalOpen(true); // เปิด Modal
  document.body.style.overflow = 'hidden'; 
};

const closeModal = () => {
  setIsModalOpen(false); // ปิด Modal
  document.body.style.overflow = 'auto'; 
};


  // Define pageContents after handleChange
  const pageContents = [
    <div>
    <form onSubmit={handleSubmit}>
    <div style={styles.fieldContainer}>
    <label style={styles.LabelText}>
      เลขที่ตามคำสั่งเปิดการศึกษา
    </label>
    <input
      type="text"
      name="education_number"
      value={userData.education_number}
      onChange={(e) => setUserData({ ...userData, educationNumber: e.target.value })}
      style={styles.inputEdit}
    />
    </div>
    <div style={styles.fieldContent}>
      <div style={styles.fieldContainer}>
        <label style={styles.LabelText}>ชื่อจริง</label>
        <input
          type="text"
          name="first_name"
          value={userData.first_name}
          onChange={(e) => setUserData({ ...userData, first_name: e.target.value })}
          style={styles.inputEdit}
        />
      </div>
      <div style={styles.fieldContainer}>
        <label style={styles.LabelText}>นามสกุล</label>
        <input
          type="text"
          name="last_name"
          value={userData.last_name}
          onChange={handleChange}
          style={styles.inputEdit}
        />
      </div>
      <div style={styles.fieldContainer}>
        <label style={styles.LabelText}>ชื่อเล่น</label>
        <input
          type="text"
          name="nick_name"
          value={userData.nick_name}
          onChange={handleChange}
          style={styles.inputEdit}
        />
      </div>
    </div>
    <div style={styles.fieldContent}>
    <div style={styles.fieldContainer}>
        <label style={styles.LabelText}>ยศ</label>
        <input
          type="text"
          name="rank_position"
          value={userData.rank_position}
          onChange={handleChange}
          style={styles.inputEdit}
        />
      </div>
        <div style={styles.fieldContainer}>
        <label style={styles.LabelText}>ตำแหน่งปัจจุบัน (ย่อ)</label>
        <input
          type="text"
          name="short_position"
          value={userData.short_position}
          onChange={handleChange}
          style={styles.inputEdit}
        />
      </div>
      <div style={styles.fieldContainer}>
        <label style={styles.LabelText}>ตำแหน่งปัจจุบัน (เต็ม)</label>
        <input
          type="text"
          name="full_position"
          value={userData.full_position}
          onChange={handleChange}
          style={styles.inputEdit}
        />
      </div>
    </div>
    <div style={styles.fieldContent}>
    <div style={styles.fieldContainer}>
        <label style={styles.LabelText}>วัน เดือน ปีเกิด</label>
        <input
          type="date"
          name="birthday"
          value={userData.birthday}
          onChange={handleChange}
          style={styles.inputEdit}
        />
      </div>
      <div style={styles.fieldContainer}>
        <label style={styles.LabelText}>ศาสนา</label>
        <input
          type="text"
          name="religion"
          value={userData.religion}
          onChange={handleChange}
          style={styles.inputEdit}
        />
      </div>
      <div style={styles.fieldContainer}>
        <label style={styles.LabelText}>สถานภาพ</label>
        <input
          type="text"
          name="marital_status"
          value={userData.marital_status}
          onChange={handleChange}
          style={styles.inputEdit}
        />
        </div>
    </div>
    <div style={styles.fieldContent}>
      <div style={styles.fieldContainer}>
        <label style={styles.LabelText}>อีเมล</label>
        <input
          type="email"
          name="email"
          value={userData.email}
          onChange={handleChange}
          style={styles.inputEdit}
        />
      </div>
      <div style={styles.fieldContainer}>
        <label style={styles.LabelText}>เบอร์โทรศัพท์</label>
        <input
          type="tel"
          name="phone"
          value={userData.phone}
          onChange={handleChange}
          style={styles.inputEdit}
        />
      </div>
    </div>
    <div style={styles.fieldContent}>
    <div style={styles.fieldContainer}>
        <label style={styles.LabelText}>เบอร์โทรติดต่อในกรณีฉุกเฉิน</label>
        <input
          type="tel"
          name="emergency_contact_phone"
          value={userData.emergency_contact_phone}
          onChange={handleChange}
          style={styles.inputEdit}
        />
      </div>
      <div style={styles.fieldContainer}>
        <label style={styles.LabelText}>ความสัมพันธ์กับเจ้าของเบอร์โทร</label>
        <input
          type="tel"
          name="emergency_contact_relationship"
          value={userData.emergency_contact_relationship}
          onChange={handleChange}
          style={styles.inputEdit}
        />
      </div>
    </div>
    <div style={{ ...styles.column, width: '49%' }}>
  <label style={{ ...styles.LabelText, paddingLeft: '10px' }}>
    รูปภาพหน้าตรงของตนเอง (รูปที่ถูกต้องตามระเบียบ)
  </label>
  <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
    {/* ช่องสำหรับแสดงชื่อไฟล์ */}
     <input
        type="text"
        id="fileName"
        value={fileName}
        style={{ ...styles.searchInput, flex: 1, marginRight: '10px' }}
    /> 
    {/* ช่องเลือกไฟล์ */}
    <input
        type="file"
        ref={fileInputRef}
        onChange={onFileChange}
        style={{ display: 'none' }}
        accept={imageFileTypes.map(type => type.accept).join(',')}
    /> 
    {/* ปุ่ม Browse */}
    <button
      style={{ ...styles.buttonBrowse, maxWidth: '100px', padding: '8px 15px' }} // เพิ่ม padding ให้ปุ่ม
      onClick={(e)=>onUploadFile(e)}
    >
      Browse
    </button>
  </div>
  <label style={styles.warningText}>*ขนาดไฟล์ไม่เกิน 1 MB</label>
</div>
        </form>
  </div>,
    <div>
      <form onSubmit={handleSubmit}>
        <div style={styles.fieldContent}>
          <div style={styles.fieldContainer}>
            <label style={styles.LabelText}>สังกัด</label>
            <input
              type="text"
              name="department"
              value={userData.department}
              onChange={handleChange}
              style={styles.inputEdit}
            />
          </div>
          <div style={styles.fieldContainer}>
            <label style={styles.LabelText}>เหล่าทหาร</label>
            <input
              type="text"
              name="military_branch"
              value={userData.military_branch}
              onChange={handleChange}
              style={styles.inputEdit}
            />
          </div>
          <div style={styles.fieldContainer}>
            <label style={styles.LabelText}>จำพวกทหาร</label>
            <input
              type="text"
              name="military_type"
              value={userData.military_type}
              onChange={handleChange}
              style={styles.inputEdit}
            />
          </div>
        </div>
        <div>
          <label style={{...styles.LabelText,paddingLeft:'10px'}}>
            ภูมิลำเนา
          </label>
          <textarea
            name="hometown"
            value={userData.hometown}
            onChange={handleChange}
            style={styles.textAreaHometown}
          />
        </div>
        <div>
          <label style={{...styles.LabelText,paddingLeft:'10px'}}>
            หน้าที่ความรับผิดชอบโดยสังเขป
          </label>
          <textarea
            name="responsibility"
            value={userData.responsibility}
            onChange={handleChange}
            style={styles.textArea}
          />
        </div>
        <div>
          <label style={styles.LabelText}>
            หลักสูตรต่าง ๆ ที่เคยศึกษาขณะรับราชการ
          </label>
          <textarea
            name="training_course"
            value={userData.training_course}
            onChange={handleChange}
            style={styles.textArea}
          />
        </div>
      </form>
    </div>,
    <div>
      <form onSubmit={handleSubmit}>
      <div style={styles.fieldContainer}>
        <label style={{...styles.LabelText,paddingLeft:'10px'}}>
          บริเวณที่พำนักขณะเข้ารับการศึกษา (ตำบล/แขวง)
        </label>
        <textarea
          name="residence_during_study"
          value={userData.residence_during_study}
          onChange={handleChange}
          style={styles.textAreaHometown}
        />
      </div>
      <div style={styles.fieldContainer}>
        <label style={{...styles.LabelText,paddingLeft:'10px'}}>
          วิธีการเดินทางมาศึกษา
        </label>
          <input
              type="text"
              name="transportation_method"
              value={userData.transportation_method}
              onChange={handleChange}
              style={styles.inputEdit}
            />
      </div>
      <div style={styles.fieldContainer}>
        <label style={styles.LabelText}>
          ทะเบียนรถที่ใช้เดินทางมาศึกษา        
        </label>
        <input
              type="text"
              name="vehicle_registration_number"
              value={userData.vehicle_registration_number}
              onChange={handleChange}
              style={styles.inputEdit}
          />
      </div>
    </form>
  </div>,
    <div>
      <form onSubmit={handleSubmit}>
    <div style={styles.fieldContainer}>
      <label style={{...styles.LabelText,paddingLeft:'10px'}}>
      หมู่โลหิต
      </label>
        <input
            type="text"
            name="blood_group"
            value={userData.blood_group}
            onChange={handleChange}
            style={styles.inputEdit}
          />
    </div>
    <div style={styles.fieldContainer}>
      <label style={{...styles.LabelText,paddingLeft:'10px'}}>
      โรคประจำตัว
      </label>
        <input
            type="text"
            name="chronic_illness"
            value={userData.chronic_illness}
            onChange={handleChange}
            style={styles.inputEdit}
          />
    </div>
    <div style={styles.fieldContainer}>
      <label style={styles.LabelText}>
      อาหารที่แพ้/สิ่งที่แพ้        
      </label>
      <input
            type="text"
            name="allergy"
            value={userData.allergy}
            onChange={handleChange}
            style={styles.inputEdit}
        />
    </div>
    <div style={styles.fieldContainer}>
      <label style={styles.LabelText}>
      ยาที่แพ้        
      </label>
      <input
            type="text"
            name="drug_allergy"
            value={userData.drug_allergy}
            onChange={handleChange}
            style={styles.inputEdit}
        />
    </div>
    <div style={styles.fieldContainer}>
      <label style={styles.LabelText}>
      ข้อจำกัดด้านร่างกายที่ผู้ควบคุมหลักสูตรจำเป็นต้องรับทราบ
      </label>
      <input
            type="text"
            name="physical_limitation"
            value={userData.physical_limitation}
            onChange={handleChange}
            style={styles.inputEdit}
        />
    </div>
  </form>
</div>,
    <div>
      <form onSubmit={handleSubmit}>
    <div style={styles.fieldContainer}>
      <label style={{...styles.LabelText,paddingLeft:'10px'}}>
      การศึกษาสูงสุด (ระบุวุฒิ สาขา และสถานศึกษาที่จบ)
      </label>
        <input
            type="text"
            name="highest_education_level"
            value={userData.highest_education_level}
            onChange={handleChange}
            style={styles.inputEdit}
          />
    </div>
    <div style={styles.fieldContainer}>
      <label style={{...styles.LabelText,paddingLeft:'10px'}}>
      งานอดิเรก (สิ่งที่ทำในยามว่างและมีประโยชน์)
      </label>
        <input
            type="text"
            name="hobby"
            value={userData.hobby}
            onChange={handleChange}
            style={styles.inputEdit}
          />
    </div>
  </form>
    </div>
  ];

  const nextPage = () => {
    if (activePage < pages.length - 1) {
      setActivePage(activePage + 1);
    }
  };

  const prevPage = () => {
    if (activePage > 0) {
      setActivePage(activePage - 1);
    }
  };

  return (
    <main style={{ paddingTop: '90px' }}>
      <div style={styles.background}></div>
      <div style={styles.container}>
        <h1 style={{ textAlign: 'left' }}>แก้ไขโปรไฟล์</h1>
        <div style={styles.navigationBar}>
          {pages.map((page, index) => (
            <div
              key={index}
              style={{
                ...styles.navItem,
                ...(activePage === index ? styles.active : {}),
                opacity: activePage === index ? 1 : 0.5,  // เปลี่ยน opacity เมื่อไม่ใช่หน้า active
                pointerEvents: activePage === index ? 'auto' : 'none',  // คลิกได้เฉพาะหน้า active
              }}
            >
              {page}
            </div>
          ))}
        </div>
        <div style={styles.content}>
          {pageContents[activePage]}
        </div>
        <div style={styles.buttons}>
        <button
          style={styles.buttonBack}
          onClick={() => {
            if (activePage === 0) {
              navigate('/profile'); // ใช้ navigate เปลี่ยนเส้นทางไปหน้า /profile
            } else {
              prevPage(); // เรียกฟังก์ชัน prevPage ถ้าไม่ใช่หน้าแรก
            }
          }}
          disabled={false}
        >
          ย้อนกลับ
        </button>
          
          {activePage === pages.length - 1 ? (
            // เมื่อถึงหน้าสุดท้ายให้ใช้ type="submit"
            <button
              type="submit"
              style={styles.buttonNext}
              disabled={false}
              onClick={openModal}
            >
              ส่ง
            </button>
          ) : (
            // เมื่อยังไม่ถึงหน้าสุดท้ายให้ใช้ type="button"
            <button
              type="button"
              style={styles.buttonNext}
              onClick={nextPage}  // เรียกฟังก์ชัน nextPage
              disabled={false}
            >
              ถัดไป
            </button>
          )}
        </div>
      </div>
      {/* Modal */}
      {isModalOpen && (
        <div  id="modal-background"
          style={styles.modalConfirm}
        >
          <div
            style={styles.modalContent}
          >
            <h3 style={{fontSize:'1.5vw'}}>ยืนยันการแก้ไขข้อมูลผู้เรียน</h3>
            <p style={{fontSize:'1.5vw'}}>คุณต้องการยืนยันข้อมูลการแก้ไขข้อมูลผู้เรียนใช่หรือไม่?</p>
            <div style={styles.btnConCan}>
              <button
                onClick={closeModal}
                style={styles.btnCancel}
              >
                ยกเลิก
              </button>
              <button
                onClick={handleSubmit}
                style={styles.btnConfirm}
              >
                ยืนยันการแก้ไขข้อมูลผู้เรียน
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};
  const styles = {
  background: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: '0',
    left: '0',
    backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.25)), url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    zIndex: '-1',
    boxSizing: 'border-box'
  },
  container: {
    boxSizing: 'border-box',
    background:' #f2f2f2',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '95%',
    borderRadius: '36px',
    margin: '25px auto', // จัดให้อยู่ตรงกลางในแนวนอน
    padding: '24px',
    gap:'24px',
    minHeight:'552'
  },
  navigationBar: {
    display: 'flex',
    marginBottom: '20px',
    boxSizing: 'border-box',
    gap:'8px'
  },
  navItem: {
    backgroundColor: '#44526E',
    color: 'white',
    borderRadius: '1000px',
    width: '100%',
    boxSizing: 'border-box',
    fontSize:'1vw',
    padding:'2px',
  },
  active: {
    backgroundColor: '#44526E',
    color: 'white'
  },
  content: {
    marginTop: '20px'
  },
  inputEdit:{
    width: '100%',
    background:'#f9fafb',
    border:'none',
    fontSize:'1vw',
    borderRadius:'81px',
    padding:'10px',
    minHeight:'77px',
    margin:'5px 0'
  },
  LabelText:{
    textAlign: 'left', 
    display: 'block', 
    width: '100%',
    fontSize:'1vw',
  },
  fieldContent: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 0',
    gap:'24px'
  },
  
  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    margin: '0 10px',
    padding: '10px 0',
  },
  inputEdit: {
    width: '100%',
    padding: '8px',
    borderRadius: '15px', // ขอบมน
    border: 'none',
  },
  fieldContainerIMG:{
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    margin: '0 10px',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '20px',
  },
  searchInput: {
    flex: 1,
    padding: '8px',
    borderRadius: '15px',
    border: 'none',
    backgroundColor: 'white',
    position: 'relative',
  },
  buttonBrowse: {
    backgroundColor: '#44526E',
    color: 'white',
    borderRadius: '1000px',
    border: 'none',
    padding: '10px 20px',
    cursor: 'pointer',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    transition: 'background-color 0.3s',
    position: 'absolute',
    right: '50%',
    zIndex: 2, // ให้ปุ่มอยู่ข้างบนของ input
  },
  warningText:{
    color:'red',
    fontSize:'0.8vw',
    textAlign:'left'
  },
  buttonBack: {
    padding: '10px 20px',
    backgroundColor: 'white',
    color: '#44526E',
    border: '1px solid #44526E',
    borderRadius: '64px',
    cursor: 'pointer',
    width:'100%',
    fontSize:'1vw'
  },
  buttonNext: {
    padding: '10px 20px',
    backgroundColor: '#44526E',
    color: 'white',
    border: 'none',
    borderRadius: '64px',
    cursor: 'pointer',
    width:'100%',
    fontSize:'1vw'
  },
  buttons: {
    marginTop: '20px',
    width:'100%',
    display:'flex',
    gap:'24px',
  },
  textArea:{
    width:'100%',
    border: 'none',
    boxSizing:'border-box',
    height:'150px',
    resize: 'vertical',
    padding:'20px',
    fontSize:'16px',
    marginBottom:'20px',
    borderRadius:'20px',
    background:'white',
  },
  textAreaHometown:{
    width:'100%',
    border: 'none',
    boxSizing:'border-box',
    height:'77px',
    resize: 'vertical',
    padding:'20px',
    fontSize:'16px',
    marginBottom:'20px',
    borderRadius:'20px',
    background:'white',
  },
  modalConfirm:{
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '1000',
  },
  modalContent:{
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    width: '90%',
    textAlign: 'center',
  },
  btnConfirm:{
    padding: '10px',
    backgroundColor: '#44526e',
    color: '#fff',
    border: 'none',
    borderRadius: '64px',
    cursor: 'pointer',
    marginRight: '10px',
    width:'100%',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    fontWeight:'bold',
    fontSize:'1vw'
  },
  btnCancel:{
    padding: '10px',
    backgroundColor: 'white',
    color: '#44526e',
    border: '1px solid #44526e',
    borderRadius: '64px',
    cursor: 'pointer',
    marginRight: '10px',
    width:'100%',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    fontWeight:'bold',
    fontSize:'1vw'
  },
  btnConCan:{
    display:'flex'
  }
};

export default EditProfilePage;
